import PropTypes from 'prop-types';
import { ALL_COUNTRIES } from 'front-onceforall-core/dist/utils/country';
import { addressPropTypes } from 'front-onceforall-core/dist/utils/address';
import { PROJECT_ASPECT } from './constant';
export const projectPropTypes = () => PropTypes.shape({
  name: PropTypes.string.isRequired,
  address: addressPropTypes().isRequired,
  country: PropTypes.oneOf(ALL_COUNTRIES).isRequired,
  openingDate: PropTypes.string.isRequired,
  closingDate: PropTypes.string.isRequired,
  requiredDocumentTypeCodes: PropTypes.arrayOf(PropTypes.string).isRequired,
  properties: projectPropertiesPropTypes().isRequired
});
export const projectPropertiesPropTypes = () => PropTypes.exact({
  aspects: PropTypes.arrayOf(PropTypes.oneOf(Object.values(PROJECT_ASPECT))).isRequired
});
export const requestPropTypes = () => PropTypes.shape({
  id: PropTypes.number.isRequired,
  project: PropTypes.object.isRequired,
  subcontractorId: PropTypes.number,
  creatorOrganisationId: PropTypes.number.isRequired,
  creatorUserId: PropTypes.string.isRequired,
  details: PropTypes.string.isRequired,
  amount: PropTypes.number.isRequired,
  creationDate: PropTypes.string.isRequired,
  startingDate: PropTypes.string.isRequired,
  endingDate: PropTypes.string.isRequired,
  paymaster: PropTypes.string.isRequired,
  status: PropTypes.string.isRequired,
  documents: PropTypes.array,
  activeTasks: PropTypes.array.isRequired,
  suspensiveConditions: PropTypes.array,
  refusalReason: PropTypes.string,
  refusalDate: PropTypes.string,
  refusalOrganisationId: PropTypes.number
});